// extracted by mini-css-extract-plugin
module.exports = {"root":"FamilyBannerShop_root__p7yrU","familyBanner":"FamilyBannerShop_familyBanner__7Vp3K","imageContainer":"FamilyBannerShop_imageContainer__taWWA"};